import React, {
  useEffect,
  useMemo,
  useState,
  useCallback,
  useRef,
} from "react";
import LoadingOverlay from "react-loading-overlay";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { httpGetAllVendorDetail } from "../../../../service/httpClient";
import "./AllVendors.css";
import CustomGridToolTip from "../../../Common/Tooltip/CustomGridToolTip";
import "../../../Common/Tooltip/CustomGridToolTip.css";

const stringDataComparator = (valueA, valueB) => {
  const valueALower =
    valueA && valueA !== "" ? valueA.toLowerCase().trim() : valueA;
  const valueBLower =
    valueB && valueB !== "" ? valueB.toLowerCase().trim() : valueB;
  if (valueALower && valueBLower) {
    return valueALower === valueBLower
      ? 0
      : valueALower.localeCompare(valueBLower, "en", { numeric: true });
  } else if (valueALower && (valueBLower === null || valueBLower === "")) {
    return -1;
  } else if ((valueALower === null || valueALower === "") && valueBLower) {
    return 1;
  } else {
    return -1;
  }
};

const operatingDivisionComparator = (valueA, valueB) => {
  const valueALower =
    valueA && valueA !== "" ? valueA.toLowerCase().trim() : valueA;
  const valueBLower =
    valueB && valueB !== "" ? valueB.toLowerCase().trim() : valueB;
  const arrayValueA =
    valueALower && valueALower.indexOf(",") > -1
      ? valueALower.split(",")
      : valueALower && valueALower !== ""
      ? [valueALower]
      : [];
  const arrayValueB =
    valueBLower && valueBLower.indexOf(",") > -1
      ? valueBLower.split(",")
      : valueBLower && valueBLower !== ""
      ? [valueBLower]
      : [];
  const valueA0 =
    arrayValueA.length !== 0 && arrayValueA[0] ? arrayValueA[0] : null;
  const valueA1 =
    arrayValueA.length !== 0 && arrayValueA[1] ? arrayValueA[1] : null;
  const valueA2 =
    arrayValueA.length !== 0 && arrayValueA[2] ? arrayValueA[2] : null;
  const valueA3 =
    arrayValueA.length !== 0 && arrayValueA[3] ? arrayValueA[3] : null;
  const valueB0 =
    arrayValueB.length !== 0 && arrayValueB[0] ? arrayValueB[0] : null;
  const valueB1 =
    arrayValueB.length !== 0 && arrayValueB[1] ? arrayValueB[1] : null;
  const valueB2 =
    arrayValueB.length !== 0 && arrayValueB[2] ? arrayValueB[2] : null;
  const valueB3 =
    arrayValueB.length !== 0 && arrayValueB[3] ? arrayValueB[3] : null;

  if (valueA0 && valueB0) {
    if (valueA0 === valueB0) {
      if (valueA1 && valueB1) {
        if (valueA1 === valueB1) {
          if (valueA2 && valueB2) {
            if (valueA2 === valueB2) {
              if (valueA3 && valueB3) {
                if (valueA3 === valueB3) {
                  return 0;
                } else {
                  return valueA3.localeCompare(valueB3, "en", {
                    numeric: true,
                  });
                }
              } else if (valueA3 && (valueB3 === null || valueB3 === "")) {
                return -1;
              } else if ((valueA3 === null || valueA3 === "") && valueB3) {
                return 1;
              } else {
                return 0;
              }
            } else {
              return valueA2.localeCompare(valueB2, "en", { numeric: true });
            }
          } else if (valueA2 && (valueB2 === null || valueB2 === "")) {
            return -1;
          } else if ((valueA2 === null || valueA2 === "") && valueB2) {
            return 1;
          } else {
            return 0;
          }
        } else {
          return valueA1.localeCompare(valueB1, "en", { numeric: true });
        }
      } else if (valueA1 && (valueB1 === null || valueB1 === "")) {
        return -1;
      } else if ((valueA1 === null || valueA1 === "") && valueB1) {
        return 1;
      } else {
        return 0;
      }
    } else {
      return valueA0.localeCompare(valueB0, "en", { numeric: true });
    }
  } else if (valueA0 && (valueB0 === null || valueB0 === "")) {
    return -1;
  } else if ((valueA0 === null || valueA0 === "") && valueBLower) {
    return 1;
  } else {
    return -1;
  }
};

const stringNumericDataComparator = (valueA, valueB) => {
  const valueALower =
    valueA && valueA !== "" ? valueA.toLowerCase().trim() : valueA;
  const valueBLower =
    valueB && valueB !== "" ? valueB.toLowerCase().trim() : valueB;
  if (valueALower && valueBLower) {
    if (!isNaN(valueALower) && !isNaN(valueBLower)) {
      return parseInt(valueALower, 10) === parseInt(valueBLower, 10)
        ? 0
        : parseInt(valueALower, 10) > parseInt(valueBLower, 10)
        ? 1
        : -1;
    } else if (isNaN(valueALower) && !isNaN(valueBLower)) {
      return 1;
    } else if (!isNaN(valueALower) && isNaN(valueBLower)) {
      return -1;
    } else {
      return valueALower === valueBLower
        ? 0
        : valueALower.localeCompare(valueBLower, "en", { numeric: true });
    }
  } else if (valueALower && (valueBLower === null || valueBLower === "")) {
    return -1;
  } else if ((valueALower === null || valueALower === "") && valueBLower) {
    return 1;
  } else {
    return -1;
  }
};

const documentDataComparator = (valueA, valueB) => {
  return valueA === valueB ? 0 : valueA > valueB ? 1 : -1;
};

const numericDataComparator = (valueA, valueB) => {
  //Split the values by separator " - " & " , "

  //Take the left side value
  const valueA0 =
    valueA && valueA.indexOf("-") > -1
      ? valueA.split("-")[0]
      : valueA && valueA.indexOf(",") > -1
      ? valueA.split(",")[0]
      : valueA;
  const valueB0 =
    valueB && valueB.indexOf("-") > -1
      ? valueB.split("-")[0]
      : valueB && valueB.indexOf(",") > -1
      ? valueB.split(",")[0]
      : valueB;

  //Take the right side value
  const valueA1 =
    valueA && valueA.indexOf("-") > -1
      ? valueA.split("-")[1]
      : valueA && valueA.indexOf(",") > -1
      ? valueA.split(",")[1]
      : null;
  const valueB1 =
    valueB && valueB.indexOf("-") > -1
      ? valueB.split("-")[1]
      : valueB && valueB.indexOf(",") > -1
      ? valueB.split(",")[1]
      : null;

  if (valueA0 && valueB0) {
    if (parseInt(valueA0.trim(), 10) === parseInt(valueB0.trim(), 10)) {
      if (valueA1 && valueB1 && !isNaN(valueA1) && !isNaN(valueB1)) {
        return parseInt(valueA1.trim(), 10) === parseInt(valueB1.trim(), 10)
          ? 0
          : parseInt(valueA1.trim(), 10) > parseInt(valueB1.trim(), 10)
          ? 1
          : -1;
      } else if (valueA1 && valueB1 && isNaN(valueA1) && isNaN(valueB1)) {
        return valueA1.trim().toLowerCase() === valueB1.trim().toLowerCase()
          ? 0
          : valueA1.trim().toLowerCase() > valueB1.trim().toLowerCase()
          ? 1
          : -1;
      } else {
        return 0;
      }
    } else {
      return parseInt(valueA0.trim(), 10) > parseInt(valueB0.trim(), 10)
        ? 1
        : -1;
    }
  } else if (valueA0 && valueB0 === null) {
    return -1;
  } else if (valueA0 === null && valueB0) {
    return 1;
  } else {
    return -1;
  }
};

const departmentComparator = (valueA, valueB) => {
  const arrayValueA =
    valueA && valueA.indexOf(",") > -1
      ? valueA.split(",")
      : valueA && valueA !== ""
      ? [valueA]
      : [];
  const arrayValueB =
    valueB && valueB.indexOf(",") > -1
      ? valueB.split(",")
      : valueB && valueB !== ""
      ? [valueB]
      : [];
  const valueA0 =
    arrayValueA.length !== 0 && arrayValueA[0] ? arrayValueA[0] : null;
  const valueA1 =
    arrayValueA.length !== 0 && arrayValueA[1] ? arrayValueA[1] : null;
  const valueA2 =
    arrayValueA.length !== 0 && arrayValueA[2] ? arrayValueA[2] : null;
  const valueA3 =
    arrayValueA.length !== 0 && arrayValueA[3] ? arrayValueA[3] : null;
  const valueB0 =
    arrayValueB.length !== 0 && arrayValueB[0] ? arrayValueB[0] : null;
  const valueB1 =
    arrayValueB.length !== 0 && arrayValueB[1] ? arrayValueB[1] : null;
  const valueB2 =
    arrayValueB.length !== 0 && arrayValueB[2] ? arrayValueB[2] : null;
  const valueB3 =
    arrayValueB.length !== 0 && arrayValueB[3] ? arrayValueB[3] : null;

  if (valueA0 && valueB0) {
    if (parseInt(valueA0.trim(), 10) === parseInt(valueB0.trim(), 10)) {
      if (valueA1 && valueB1) {
        if (parseInt(valueA1.trim(), 10) === parseInt(valueB1.trim(), 10)) {
          if (valueA2 && valueB2) {
            if (parseInt(valueA2.trim(), 10) === parseInt(valueB2.trim(), 10)) {
              if (valueA3 && valueB3) {
                return parseInt(valueA2.trim(), 10) ===
                  parseInt(valueB2.trim(), 10)
                  ? 0
                  : parseInt(valueA2.trim(), 10) > parseInt(valueB2.trim(), 10)
                  ? 1
                  : -1;
              } else if (valueA3 && valueB3 === null) {
                return -1;
              } else if (valueA3 === null && valueB3) {
                return 1;
              } else {
                return -1;
              }
            } else {
              return parseInt(valueA2.trim(), 10) > parseInt(valueB2.trim(), 10)
                ? 1
                : -1;
            }
          } else if (valueA2 && valueB2 === null) {
            return -1;
          } else if (valueA2 === null && valueB2) {
            return 1;
          } else {
            return -1;
          }
        } else {
          return parseInt(valueA1.trim(), 10) > parseInt(valueB1.trim(), 10)
            ? 1
            : -1;
        }
      } else if (valueA1 && valueB1 === null) {
        return -1;
      } else if (valueA1 === null && valueB1) {
        return 1;
      } else {
        return -1;
      }
    } else {
      return parseInt(valueA0.trim(), 10) > parseInt(valueB0.trim(), 10)
        ? 1
        : -1;
    }
  } else if (valueA0 && valueB0 === null) {
    return -1;
  } else if (valueA0 === null && valueB0) {
    return 1;
  } else {
    return -1;
  }
};

const gmmAndDivisionComparator = (valueA, valueB) => {
  const arrayValueA =
    valueA && valueA.indexOf(",") > -1
      ? valueA.split(",")
      : valueA && valueA !== ""
      ? [valueA]
      : [];
  const arrayValueB =
    valueB && valueB.indexOf(",") > -1
      ? valueB.split(",")
      : valueB && valueB !== ""
      ? [valueB]
      : [];
  const valueA0 =
    arrayValueA.length !== 0 && arrayValueA[0] ? arrayValueA[0] : null;
  const valueA1 =
    arrayValueA.length !== 0 && arrayValueA[1] ? arrayValueA[1] : null;
  const valueA2 =
    arrayValueA.length !== 0 && arrayValueA[2] ? arrayValueA[2] : null;
  const valueA3 =
    arrayValueA.length !== 0 && arrayValueA[3] ? arrayValueA[3] : null;
  const valueB0 =
    arrayValueB.length !== 0 && arrayValueB[0] ? arrayValueB[0] : null;
  const valueB1 =
    arrayValueB.length !== 0 && arrayValueB[1] ? arrayValueB[1] : null;
  const valueB2 =
    arrayValueB.length !== 0 && arrayValueB[2] ? arrayValueB[2] : null;
  const valueB3 =
    arrayValueB.length !== 0 && arrayValueB[3] ? arrayValueB[3] : null;

  const valueA00 =
    valueA0 && valueA0.indexOf("-") > -1 ? valueA0.split("-")[0] : valueA0;
  const valueA01 =
    valueA0 && valueA0.indexOf("-") > -1 ? valueA0.split("-")[1] : null;
  const valueA10 =
    valueA1 && valueA1.indexOf("-") > -1 ? valueA1.split("-")[0] : valueA1;
  const valueA11 =
    valueA1 && valueA1.indexOf("-") > -1 ? valueA1.split("-")[1] : null;
  const valueA20 =
    valueA2 && valueA2.indexOf("-") > -1 ? valueA2.split("-")[0] : valueA2;
  const valueA21 =
    valueA2 && valueA2.indexOf("-") > -1 ? valueA2.split("-")[1] : null;
  const valueA30 =
    valueA3 && valueA3.indexOf("-") > -1 ? valueA3.split("-")[0] : valueA3;
  const valueA31 =
    valueA3 && valueA3.indexOf("-") > -1 ? valueA3.split("-")[1] : null;

  const valueB00 =
    valueB0 && valueB0.indexOf("-") > -1 ? valueB0.split("-")[0] : valueB0;
  const valueB01 =
    valueB0 && valueB0.indexOf("-") > -1 ? valueB0.split("-")[1] : null;
  const valueB10 =
    valueB1 && valueB1.indexOf("-") > -1 ? valueB1.split("-")[0] : valueB1;
  const valueB11 =
    valueB1 && valueB1.indexOf("-") > -1 ? valueB1.split("-")[1] : null;
  const valueB20 =
    valueB2 && valueB2.indexOf("-") > -1 ? valueB2.split("-")[0] : valueB2;
  const valueB21 =
    valueB2 && valueB2.indexOf("-") > -1 ? valueB2.split("-")[1] : null;
  const valueB30 =
    valueB3 && valueB3.indexOf("-") > -1 ? valueB3.split("-")[0] : valueB3;
  const valueB31 =
    valueB3 && valueB3.indexOf("-") > -1 ? valueB3.split("-")[1] : null;

  if (valueA00 && valueB00) {
    if (parseInt(valueA00.trim(), 10) === parseInt(valueB00.trim(), 10)) {
      if (valueA01 && valueB01) {
        if (valueA01 === valueB01) {
          if (valueA10 && valueB10) {
            if (
              parseInt(valueA10.trim(), 10) === parseInt(valueB10.trim(), 10)
            ) {
              if (valueA11 && valueB11) {
                if (valueA11 === valueB11) {
                  if (valueA20 && valueB20) {
                    if (
                      parseInt(valueA20.trim(), 10) ===
                      parseInt(valueB20.trim(), 10)
                    ) {
                      if (valueA21 && valueB21) {
                        if (valueA21 === valueB21) {
                          if (valueA30 && valueB30) {
                            if (
                              parseInt(valueA30.trim(), 10) ===
                              parseInt(valueB30.trim(), 10)
                            ) {
                              if (valueA31 && valueB31) {
                                if (valueA31 === valueB31) {
                                  return 0;
                                } else {
                                  if (
                                    valueA31 &&
                                    valueB31 &&
                                    !isNaN(valueA31) &&
                                    !isNaN(valueB31)
                                  ) {
                                    return parseInt(valueA31.trim(), 10) ===
                                      parseInt(valueB31.trim(), 10)
                                      ? 0
                                      : parseInt(valueA31.trim(), 10) >
                                        parseInt(valueB31.trim(), 10)
                                      ? 1
                                      : -1;
                                  } else if (
                                    valueA31 &&
                                    valueB31 &&
                                    isNaN(valueA31) &&
                                    isNaN(valueB31)
                                  ) {
                                    return valueA31.trim().toLowerCase() ===
                                      valueB31.trim().toLowerCase()
                                      ? 0
                                      : valueA31.trim().toLowerCase() >
                                        valueB31.trim().toLowerCase()
                                      ? 1
                                      : -1;
                                  } else {
                                    return 0;
                                  }
                                }
                              }
                            } else {
                              return parseInt(valueA30.trim(), 10) >
                                parseInt(valueB30.trim(), 10)
                                ? 1
                                : -1;
                            }
                          } else if (valueA30 && valueB30 === null) {
                            return -1;
                          } else if (valueA30 === null && valueB30) {
                            return 1;
                          } else {
                            return -1;
                          }
                        } else {
                          if (
                            valueA21 &&
                            valueB11 &&
                            !isNaN(valueA21) &&
                            !isNaN(valueB21)
                          ) {
                            return parseInt(valueA21.trim(), 10) ===
                              parseInt(valueB21.trim(), 10)
                              ? 0
                              : parseInt(valueA21.trim(), 10) >
                                parseInt(valueB21.trim(), 10)
                              ? 1
                              : -1;
                          } else if (
                            valueA21 &&
                            valueB21 &&
                            isNaN(valueA21) &&
                            isNaN(valueB21)
                          ) {
                            return valueA21.trim().toLowerCase() ===
                              valueB21.trim().toLowerCase()
                              ? 0
                              : valueA21.trim().toLowerCase() >
                                valueB21.trim().toLowerCase()
                              ? 1
                              : -1;
                          } else {
                            return 0;
                          }
                        }
                      }
                    } else {
                      return parseInt(valueA20.trim(), 10) >
                        parseInt(valueB20.trim(), 10)
                        ? 1
                        : -1;
                    }
                  } else if (valueA20 && valueB20 === null) {
                    return -1;
                  } else if (valueA20 === null && valueB20) {
                    return 1;
                  } else {
                    return -1;
                  }
                } else {
                  if (
                    valueA11 &&
                    valueB11 &&
                    !isNaN(valueA11) &&
                    !isNaN(valueB11)
                  ) {
                    return parseInt(valueA11.trim(), 10) ===
                      parseInt(valueB11.trim(), 10)
                      ? 0
                      : parseInt(valueA11.trim(), 10) >
                        parseInt(valueB11.trim(), 10)
                      ? 1
                      : -1;
                  } else if (
                    valueA11 &&
                    valueB11 &&
                    isNaN(valueA11) &&
                    isNaN(valueB11)
                  ) {
                    return valueA11.trim().toLowerCase() ===
                      valueB11.trim().toLowerCase()
                      ? 0
                      : valueA11.trim().toLowerCase() >
                        valueB11.trim().toLowerCase()
                      ? 1
                      : -1;
                  } else {
                    return 0;
                  }
                }
              }
            } else {
              return parseInt(valueA10.trim(), 10) >
                parseInt(valueB10.trim(), 10)
                ? 1
                : -1;
            }
          } else if (valueA10 && valueB10 === null) {
            return -1;
          } else if (valueA10 === null && valueB10) {
            return 1;
          } else {
            return -1;
          }
        } else {
          if (valueA01 && valueB01 && !isNaN(valueA01) && !isNaN(valueB01)) {
            return parseInt(valueA01.trim(), 10) ===
              parseInt(valueB01.trim(), 10)
              ? 0
              : parseInt(valueA01.trim(), 10) > parseInt(valueB01.trim(), 10)
              ? 1
              : -1;
          } else if (
            valueA01 &&
            valueB01 &&
            isNaN(valueA01) &&
            isNaN(valueB01)
          ) {
            return valueA01.trim().toLowerCase() ===
              valueB01.trim().toLowerCase()
              ? 0
              : valueA01.trim().toLowerCase() > valueB01.trim().toLowerCase()
              ? 1
              : -1;
          } else {
            return 0;
          }
        }
      }
    } else {
      return parseInt(valueA00.trim(), 10) > parseInt(valueB00.trim(), 10)
        ? 1
        : -1;
    }
  } else if (valueA00 && valueB00 === null) {
    return -1;
  } else if (valueA00 === null && valueB00) {
    return 1;
  } else {
    return -1;
  }
};

const defaultColDef = {
  sortable: true,
  enablePivot: true,
  filter: true,
  resizable: true,
  tooltipComponent: CustomGridToolTip,
};

const columnDefs = [
  {
    headerName: "Vendor Name",
    field: "vendorCorpName",
    width: 150,
    cellRenderer: (params) => {
      const { data = {} } = params || {};
      const { vendorProfileId = "", vendorCorpName = "" } = data || {};
      return (
        <a href={`/boarding/merchant/${vendorProfileId}`} target="_self">
          {vendorCorpName}
        </a>
      );
    },
    comparator: stringDataComparator,
  },
  {
    headerName: "Duns",
    field: "duns",
    width: 100,
    comparator: stringNumericDataComparator,
  },
  {
    headerName: "Vendor Fulfillment Type",
    field: "fullFillmentType",
    width: 210,
    comparator: stringDataComparator,
  },
  {
    headerName: "Vendor Connection",
    field: "vendorConnection",
    width: 170,
    comparator: stringDataComparator,
  },
  {
    headerName: "Onboarding Status",
    field: "onboardStatus",
    width: 180,
    comparator: stringDataComparator,
  },
  {
    headerName: "Operating Division(s)",
    field: "opDivision",
    width: 190,
    comparator: operatingDivisionComparator,
    tooltipField: "opDivision",
  },
  {
    headerName: "GMM(s)",
    field: "gmm",
    width: 200,
    comparator: gmmAndDivisionComparator,
    tooltipField: "gmm",
  },
  {
    headerName: "Dept(s)",
    field: "dept",
    width: 130,
    comparator: departmentComparator,
  },
  // {
  //   headerName: "Additional DVNs",
  //   field: "additionalDvn",
  //   width: 175,
  //   comparator: stringDataComparator,
  //   tooltipField: "additionalDvn",
  // },
  {
    headerName: "DVN(s)",
    field: "dvn",
    width: 175,
    comparator: stringDataComparator,
    tooltipField: "dvn",
  },
  {
    headerName: "DVN Count",
    field: "dvnCount",
    width: 175,
    comparator: numericDataComparator,
    tooltipField: "dvnCount",
  },
  {
    headerName: "Brand Name(s)",
    field: "brandName",
    width: 160,
    comparator: stringDataComparator,
    tooltipField: "brandName",
  },
  {
    headerName: "Number of Documents",
    field: "noOfDocuments",
    width: 200,
    comparator: documentDataComparator,
  },
  {
    headerName: "MBE/WBE Expiration Date",
    field: "expirationDate",
    width: 200,
  },
  {
    headerName: "Division(s)",
    field: "division",
    width: 140,
    comparator: gmmAndDivisionComparator,
    hide: true,
  },
  {
    headerName: "Ven #",
    field: "vendorNumber",
    width: 100,
    hide: true,
  },
  {
    headerName: "Product Type",
    field: "productType",
    width: 140,
    comparator: stringNumericDataComparator,
    hide: true,
  },
  {
    headerName: "% Complete",
    field: "percentageComplete",
    width: 150,
    hide: true,
  },
  {
    headerName: "Annual Sales Volume",
    field: "annualSalesVolume",
    width: 190,
    comparator: numericDataComparator,
    hide: true,
  },
  {
    headerName: "MBE/WBE Status",
    field: "wbeStatus",
    width: 170,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Primary Merchant Contact Email",
    field: "primaryMerchantEmail",
    width: 240,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Primary Merchant Contact Email Role",
    field: "primaryMerchantRole",
    width: 265,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Primary Vendor Contact Email Address",
    field: "primaryVendorEmail",
    width: 280,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Vendor Registration Date",
    field: "vendorRegistrationDate",
    width: 200,
    hide: true,
  },
  {
    headerName: "Vendor Submission Date",
    field: "vendorSubmissionDate",
    width: 200,
    hide: true,
  },
  {
    headerName: "Merchant Approval Date",
    field: "merchantApprovedDate",
    width: 200,
    hide: true,
  },
  {
    headerName: "Documents Submitted Date",
    field: "doccumentSubmittedDate",
    width: 220,
    hide: true,
  },
  {
    headerName: "EIN Verification Date",
    field: "einVerificationDate",
    width: 190,
    hide: true,
  },
  {
    headerName: "Accounts Payable Approved Date",
    field: "apApprovalDate",
    width: 255,
    hide: true,
  },
  {
    headerName: "Integration Start Date",
    field: "integrationStartDate",
    width: 200,
    hide: true,
  },
  {
    headerName: "Target Live Date",
    field: "targetLiveDate",
    width: 160,
    hide: true,
  },
  {
    headerName: "OB Completed Date",
    field: "obCompleteDate",
    width: 180,
    hide: true,
  },
  {
    headerName: "Live Date",
    field: "liveDate",
    width: 140,
    hide: true,
  },
  {
    headerName: "Date Moved to Inactive",
    field: "dateMovedToHold",
    width: 200,
    hide: true,
  },
  {
    headerName: "UPS Account",
    field: "upsAccount",
    width: 150,
    comparator: stringNumericDataComparator,
    hide: true,
  },
  {
    headerName: "UPS Account Date",
    field: "upsAccountDate",
    width: 190,
    hide: true,
  },
  {
    headerName: "Vendor Line List",
    field: "vll",
    width: 160,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Vendor Line List Date",
    field: "vllDate",
    width: 180,
    hide: true,
  },
  {
    headerName: "Packing Slip",
    field: "packingSlip",
    width: 150,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Packing Slip Date",
    field: "packingSlipDate",
    width: 180,
    hide: true,
  },
  {
    headerName: "Shipping Label",
    field: "shippingLabel",
    width: 150,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Shipping Label Date",
    field: "shippingLabelDate",
    width: 190,
    hide: true,
  },
  {
    headerName: "Order Testing",
    field: "orderTesting",
    width: 140,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Order Testing Date",
    field: "orderTestingDate",
    width: 190,
    hide: true,
  },
  {
    headerName: "846 Testing",
    field: "eightFortySixTesting",
    width: 150,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "846 Testing Date",
    field: "eightFortySixTestingDate",
    width: 190,
    hide: true,
  },
  {
    headerName: "BOSS Agreement",
    field: "bossAggreement",
    width: 160,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "BOSS Agreement Date",
    field: "bossAggreementDate",
    width: 200,
    hide: true,
  },
  {
    headerName: "Page Creation",
    field: "pageCreation",
    width: 140,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Page Creation Date",
    field: "pageCreationDate",
    width: 190,
    hide: true,
  },
  {
    headerName: "CHUB Integration Profile",
    field: "chubIntegrationProfile",
    width: 220,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "CHUB Agreement Date",
    field: "chubAggreementDate",
    width: 200,
    hide: true,
  },
  {
    headerName: "CHUB Packing Slip",
    field: "chubPackingSlip",
    width: 180,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Last Note Date",
    field: "lastNoteDate",
    width: 180,
    hide: true,
  },
  {
    headerName: "Last Note User",
    field: "lastUser",
    width: 160,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Last Note Type",
    field: "lastNoteType",
    width: 160,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Last Note",
    field: "lastNote",
    width: 130,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "2nd to Last Note Date",
    field: "secondLastNoteDate",
    width: 200,
    hide: true,
  },
  {
    headerName: "2nd to Last Note User",
    field: "secondLastNoteUser",
    width: 200,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "2nd to Last Note Type",
    field: "secondLastType",
    comparator: stringDataComparator,
    width: 200,
    hide: true,
  },
  {
    headerName: "2nd to Last Note",
    field: "secondLastNote",
    width: 160,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Last Activity",
    field: "lastActivity",
    width: 150,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Last Activity Date",
    field: "lastActivityDate",
    width: 170,
    hide: true,
  },
  {
    headerName: "DVN # Needed?",
    field: "dvnNeeded",
    width: 160,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Pipeline Ownership",
    field: "plOwner",
    width: 170,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Returnless Refund Opted",
    field: "returnLessRefundOptIn",
    width: 160,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Delivery RAAS Opted",
    field: "deliveryRaasOptIn",
    width: 160,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "Delivery RAAS Return Sign Required",
    field: "dRaasSignatureRequiredForReturns",
    width: 220,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "International Seller",
    field: "isInternationalSeller",
    width: 140,
    comparator: stringDataComparator,
    hide: true,
  },
  {
    headerName: "MCC Code",
    field: "merchantCategoryCode",
    width: 100,
    comparator: numericDataComparator,
    hide: true,
  },
];

const getIncludedFilterValue = (allFilterValues = [], excludedValues = []) => {
  return allFilterValues.filter((item) => !(excludedValues.indexOf(item) > -1));
};

const setInitialFilter = (gridApi, columnId, excludedValues) => {
  const instance = gridApi && gridApi.getFilterInstance(columnId);
  if (instance) {
    const uniqueFilterValues = instance.valueModel.allValues;
    let filteredValues = getIncludedFilterValue(
      uniqueFilterValues,
      excludedValues
    );
    instance.setModel({ values: filteredValues });
  }
};

const AllVendors = () => {
  const [responseData, setResponseData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const gridRef = useRef();

  useEffect(() => {
    httpGetAllVendorDetail()
      .then((response) => {
        const statusReportResp =
          response?.data && response?.data.length > 0 ? response?.data : [];
        setResponseData(statusReportResp);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  }, []);

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressColumnExpandAll: true,
          },
        },
      ],
    };
  }, []);

  const onFirstDataRendered = useCallback((event) => {
    const gridApi = event.api;

    let filterModel = sessionStorage.getItem("all-vendor-persistence-filter");
    if (filterModel !== null) {
      gridApi.setFilterModel(JSON.parse(filterModel));
    } else {
      let vendorFulfillmentTypeExcludedValues = ["Marketplace"];
      let vendorConnectionExcludedValues = ["Macys Mirakl", "Bloomies Mirakl"];
      let onBoardingStatusExcludedValues = ["On Hold", "Live"];

      setInitialFilter(
        gridApi,
        "fullFillmentType",
        vendorFulfillmentTypeExcludedValues
      );
      setInitialFilter(
        gridApi,
        "vendorConnection",
        vendorConnectionExcludedValues
      );
      setInitialFilter(
        gridApi,
        "onboardStatus",
        onBoardingStatusExcludedValues
      );

      gridApi.onFilterChanged();
    }
    setIsLoading(false);

    let columnState = sessionStorage.getItem(
      "all-vendor-persistence-columnState"
    );

    event.columnApi.applyColumnState({
      state: JSON.parse(columnState),
      applyOrder: true,
    });
  }, []);

  const onColumnVisible = useCallback((params) => {
    if (params?.source === "toolPanelUi") {
      const colDefs = params?.columnApi?.columnModel?.columnDefs || [];
      const columnApi = params?.columnApi;
      const api = gridRef?.current?.api;
      const displayedColumns =
        params?.columnApi?.columnModel?.displayedColumns || [];
      if (displayedColumns?.length === 1) {
        const newColDefs = colDefs.map((item) => {
          if (
            displayedColumns.length &&
            item.field === displayedColumns[0].colId
          ) {
            item.lockVisible = true;
            item.visible = true;
            item.hide = false;
            return item;
          }
          item.lockVisible = false;
          item.visible = false;
          item.hide = true;

          return item;
        });
        api.setColumnDefs(newColDefs);
      } else if (displayedColumns.length === 0) {
        const newColDefs = colDefs.map((item, index) => {
          if (index === 0) {
            item.lockVisible = true;
            item.visible = true;
            columnApi.setColumnVisible(item.field, true);
            return item;
          }
          item.visible = true;
          item.lockVisible = false;
          item.hide = true;
          return item;
        });
        api.setColumnDefs(newColDefs);
      } else if (displayedColumns.length === colDefs.length) {
        displayedColumns.map((dItem, idx) => {
          dItem.lockVisible = false;
          dItem.visible = true;
          dItem.hide = false;
          if (dItem.lockVisible || idx === 0) {
            const newColDefs = colDefs.map((item, index) => {
              item.hide = false;
              if (index === 0 || item.lockVisible) {
                item.lockVisible = false;
                item.visible = true;
                return item;
              }
              item.hide = false;
              return item;
            });

            api.setColumnDefs(newColDefs);
          }
        });
      } else {
        const newColDefs = colDefs.map((item) => {
          if (item.lockVisible) {
            item.visible = true;
            item.lockVisible = false;
            item.hide = false;
            return item;
          }
          const data = displayedColumns.find(
            (dItem) => dItem.colId === item.field
          );
          if (data && data.visible) {
            item.visible = true;
            item.lockVisible = false;
            item.hide = false;
            return item;
          } else {
            item.visible = false;
            item.lockVisible = false;
            item.hide = true;
            return item;
          }
        });
        api.setColumnDefs(newColDefs);
      }
    }
  });

  const onFilterChanged = (params) => {
    sessionStorage.setItem(
      "all-vendor-persistence-filter",
      JSON.stringify(params.api.getFilterModel())
    );
  };

  const onSaveColumnState = (params) => {
    var colState = params.columnApi.getColumnState();
    sessionStorage.setItem(
      "all-vendor-persistence-columnState",
      JSON.stringify(colState)
    );
    onColumnVisible(params);
  };

  return (
    <div className="allVendors">
      <LoadingOverlay active={isLoading} spinner>
        <div className="ag-theme-balham allVendorsTable">
          <AgGridReact
            columnDefs={columnDefs}
            rowData={responseData}
            defaultColDef={defaultColDef}
            ref={gridRef}
            multiSortKey={"ctrl"}
            maintainColumnOrder={true}
            rowSelection="multiple"
            paginationPageSize="50"
            pagination={true}
            overlayNoRowsTemplate={
              responseData.length > 0 ? "" : "No data available"
            }
            enableRangeSelection={true}
            sideBar={sideBar}
            onFirstDataRendered={onFirstDataRendered}
            suppressDragLeaveHidesColumns={true}
            onSortChanged={onSaveColumnState}
            onFilterChanged={onFilterChanged}
            onColumnMoved={onSaveColumnState}
            onColumnVisible={onSaveColumnState}
          />
        </div>
      </LoadingOverlay>
    </div>
  );
};

export default AllVendors;
